const zh = {
  home: {
    menuName: '首页'
  },
  service: {
    menuName: '服务项目',
    subMenu1: '中心影像服务',
    subMenu2: '三维后处理服务',
    msg1: '展影医疗将图像处理和人工智能技术应用于影像医学，并且按照国际上权威、3D影像临床诊断标准，为广大医生和患者提供与临床紧密相关的影像数据分析和诊断服务。同时，利用云平台优势，展影医疗还为客户提供医学影像大数据的传输、存储、共享、统计和质量控制等服务。'
  },
  imagingService: {
    tab1: '中心影像服务',
    tab2: '评估标准',
    tab3: '适应症',
    tab4: '业务管理云平台',
    tab5: '团队优势',
    tab6: '影像评估系统',
    title1: '业务范围',
    title2: '服务内容',
    title3: '业务流程',
    title4: '系统主要优点',
    title5: '专家团队',
    title6: '运营团队',
    msg1: '无论您是大型药厂、生物技术公司、CRO，还是医疗科研机构，展影医疗竭诚为您提供与临床试验相关的医学影像服务。',
    msg2: '每个临床试验项目都是独特的，面临着不同的要求和挑战。展影医疗为您提供一系列的医学影像服务，涵盖从早期研发项目，到旨在获得上市批准的大规模国际多中心研究项目。',
    msg3: '非肿瘤评估标准',
    msg4: '多中心临床试验的参与方越来越多，所涉及的影像数据量也越来越大，同时，监管的要求也越来越严格。有鉴于此，展影医疗研发了基于云平台的中心影像全流程业务管理系统，以方便沟通，缩短响应时间，并保证数据的安全性和可追溯性。',
    msg5: '展影医疗的业务管理云平台，能有效地管理中心影像项目工作流程的每一步，从研究机构采集影像数据，一直到向监管机构提交结果数据。',
    msg6: '全球范围内的所有的项目参与方，都能保持实时沟通，并能随时了解项目的进展情况。',
    msg7: '展影医疗基于云平台的影像评估系统是专门为临床试验中心影像项目而设计研发的，注重于消除阅片人的主观偏倚，提高测量和定量分析的效率和准确性，保证数据安全和结果的可追溯性。该系统包含面向Dicom和非标准数据的浏览工具，各种针对肿瘤靶病灶的测量工具，并且内置了针对不同疾病、不同评估标准的eCRF表格。人工智能、影像组学、三维重建技术的深度运用，极大地提高了影像评估的效率，拓展了评估标准和适应症的范围。',
    msg7_1: '',
    msg7_2: '',
    msg7_3: '',
    msg8: '支持云端或本地部署，保证影像评估工作安全、合规、方便地开展',
    msg9: '测量结果自动输出到包含评估标准的eCRF表格，保证了数据和结果的准确性和可靠性',
    msg10: '多种靶病灶测量工具可供阅片专家选择',
    msg11: '支持各种影像设备的标准Dicom数据，以及其它非标准影像、临床数据',
    msg12: '符合各种监管要求：NMPA、FDA 510K、CE、21 CFR Part 11、GxP、HIPPA',
    msg13: '展影医疗在临床试验中心影像服务领域的优势，离不开我们行业经验丰富、工作态度严谨的运营团队，以及内部和外部专家团队在专业知识上对项目全方位的支持。',
    msg14: '国内外专家团队涵盖影像、肿瘤、骨科、血液、五官等专业',
    msg15: '海外资深专家供职于麻省总医院, Dana-Farber , Sloan Kettering 等医疗机构，个人参与项目数超500，人均年度评估量2万访视点以上',
    msg16: '国内专家来自于京沪大型三甲医院，中心影像项目实战经验丰富',
    msg17: '顾问委员会成员包括ACR、RSNA、中华放射学会的主委、副主委级别专家',
    msg18: '2017年起，与哈佛医学院合作，开展针对中国影像、临床医生的独立中心评估专业化培训',
    msg19: '项目经理（Project Manager）团队的项目管理经验合计100项以上',
    msg20: '医学团队由中美两国具有影像、临床背景的资深医师组成，许多曾供职于两国排名前10的医疗机构',
    msg21: '质控人员都具有临床或影像医学背景',
    msg22: 'IT平台研发管理人员有多年的医疗信息化产业经验'
  },
  processingService: {
    tab1: '三维影像后处理服务',
    tab2: '服务项目',
    tab3: '服务流程',
    tab4: '方案展示',
    tab5: '3D Reconstructions',
    tab6: 'Image-Based Surgical Planning',
    title1: '3-D Post-Processing Service',
    title2: 'Benefits to Clients',
    title3: 'Regulatory Compliance',
    title4: 'Cardiovascular',
    title5: 'Neurological',
    title6: 'Thoracic',
    title7: 'Abdominal',
    title8: 'Musculoskeletal',
    title9: 'Liver Mass',
    title10: 'Femoral Shaft Fracture',
    title11: 'Transcatheter Aortic Valve Implantation (TAVI)',
    title12: 'Kidney Mass',
    title13: 'Pancreatic Tumor',
    title14: 'Abdominal Aortic Aneurysm (AAA)',
    msg1: '医学图像（主要是CT、磁共振图像）的三维重建已经成为临床实践中一项不可缺少的技术服务。随着临床影像需求的多样化、复杂化，医疗机构在如何为医生提供高质量、成本合理的三维重建解决方案上，面临着巨大的挑战。展影医疗是一家国际性的医学图像后处理第三方服务机构。公司多年来培养了一支经过专门培训、熟练掌握三维重建技术的临床和影像医师队伍；拥有医学影像图形工作站和经过临床验证的人体各部位、各病种三维重建方案。展影医疗与客户医院的临床团队紧密合作，用医学图像后处理技术为临床诊疗提供影像学支持。公司目前为中美两国上百家医院提供每天24小时、全年不间歇的医学图像三维重建服务。',
    msg2: '低成本、可扩展的一站式三维重建解决方案',
    msg3: '24/7全年服务、响应时间短',
    msg4: '专业的重建团队、高质量的三维重建',
    msg5: '客户的医技人员可以专注于CT/磁共振扫描',
    msg6: '帮助客户开展新的临床诊疗项目',
    msg7: `Data transmission on our HIPPA-compliant network is encrypted with sophisticated algorithms. Image data
          is anonymized prior to transmission from the hospital, then stored at our data center with 24/7 security
          and back-up. Our radiologists process the images without knowledge of patients' identities.`,
    msg8: `Everest Digital Medicine offers a wide range of 3-D post-processing services for CT and MRI studies.
          These services encompass reconstructions, quantitative analysis, and image-based surgical planning.`,
    msg9: `Our radiologists and imaging specialists work with clients to design customized protocols based on their
          clinical requirements.`,
    msg10: 'The following two tables are a list of protocols of 3D reconstruction, and image-based surgical planning.',
    msg11: 'Image data is anonymized and sent to our 3D lab via HIPPA compliant VPN network.',
    msg12: 'Our radiologists process 2D images on FDA-cleared 3D workstations.',
    msg13: 'Resulting 3D images are sent back to clients\' PACS for physician reading',
    msg14: 'Please click to enlarge!',
    table_Reconstructions: {
      th1: 'Body Systems',
      th2: '3D Post-Processing Protocols',
      td1: 'Cardiovascular',
      td2: 'Cardiac CTA, aorta CTA, coronary artery analysis,pulmonary CTA, CT venogram, coronary score, ejection fraction, & measurements for stenting',
      td3: 'Neurological',
      td4: 'Head CTA, head CT venogram, & neck CTA',
      td5: 'Thoracic',
      td6: 'Chest/trachea VR, pulmometry, & tumor pre-surgical',
      td7: 'Abdominal',
      td8: 'Liver CTA, pancreatic CTA, mesenteric CTA, renal CTA, pelvic CTA, abdominal VR, & virtual endoscopy',
      td9: 'Musculoskeletal',
      td10: `Bone CT/CTA, VR & joint view for facial fracture, collum femoris fracture,
            thoracic fracture, shoulder fracture, pelvic fracture, limb fracture, bone implant VR, &
            TT-GT measurement`
    },
    table_ImageBased: {
      th1: 'Subspecialties',
      th2: 'Protocols',
      td1: 'Cardiovascular',
      td2: 'Coronary disease intervention, aortic and dissecting aneurysms interventional, TAVI, & left atrial appendage closure(LAAC)',
      td3: 'Head and Neck',
      td4: 'Intracranial angioma, & carotid artery stenosis disease interventional therapy',
      td5: 'Thoracic',
      td6: 'Lung nodule follow-up, lung and mediastinum tumors pre-surgical, & emphysema treatment',
      td7: 'Abdominal',
      td8: 'Hepatic tumor, gastric tumor, pancreatic tumor, renal tumor, adrenal tumor, renal transplant, & renal calculus pre-surgical',
      td9: 'Oskeletal',
      td10: 'Fractures VR & measurement',
      td11: 'Pediatric surgical',
      td12: 'Congenital abnormalities of the urinary system, digestive tract and skeletal bone,& congenital heart disease'
    }
  },
  about: {
    menuName: '关于我们'
  },
  media: {
    menuName: '媒体报道'
  },
  book: {
    menuName: '预约演示'
  },
  login: {
    menuName: '登录'
  }
}

export default zh
